import { render, staticRenderFns } from "./withdrawTransfer.vue?vue&type=template&id=6aa0fede&scoped=true"
import script from "./withdrawTransfer.vue?vue&type=script&lang=js"
export * from "./withdrawTransfer.vue?vue&type=script&lang=js"
import style0 from "./withdrawTransfer.vue?vue&type=style&index=0&id=6aa0fede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa0fede",
  null
  
)

export default component.exports